module.exports = __webpack_public_path__ + "static/media/add game.87dfc78d.svg";